import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center pa-8"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "timelapse-overlay-top" }
const _hoisted_4 = { class: "timelapse-overlay-bottom" }
const _hoisted_5 = { class: "d-flex align-center mt-3 px-2" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex mt-2 overflow-x-auto",
  style: {"gap":"4px"}
}
const _hoisted_7 = ["onClick"]

import { ref, computed, onBeforeUnmount, watch } from 'vue'

interface TimelapseSample {
    imageUrl: string
    time: Date
    growthPercent?: number
    managed?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RootTimelapse',
  props: {
    samples: {},
    intervalMs: { default: 1500 },
    height: { default: '450px' }
  },
  setup(__props: any) {

const props = __props

const currentIndex = ref(0)
const playing = ref(false)
const speed = ref(props.intervalMs)
let timer: number | null = null

// Samples con imagen, ordenadas cronológicamente (antigua → reciente)
const timelapseFrames = computed(() => {
    return [...props.samples]
        .filter(s => s.imageUrl && s.imageUrl.trim() !== '')
        .sort((a, b) => new Date(a.time).getTime() - new Date(b.time).getTime())
})

const currentFrame = computed(() => timelapseFrames.value[currentIndex.value] || null)

const progress = computed(() => {
    if (timelapseFrames.value.length <= 1) return 100
    return Math.round((currentIndex.value / (timelapseFrames.value.length - 1)) * 100)
})

const formatDate = (date: Date) => {
    return new Intl.DateTimeFormat('es-CL', {
        day: '2-digit', month: '2-digit', year: '2-digit',
        hour: '2-digit', minute: '2-digit'
    }).format(new Date(date))
}

const play = () => {
    if (timelapseFrames.value.length <= 1) return
    playing.value = true
    timer = window.setInterval(() => {
        if (currentIndex.value >= timelapseFrames.value.length - 1) {
            currentIndex.value = 0
        } else {
            currentIndex.value++
        }
    }, speed.value)
}

const pause = () => {
    playing.value = false
    if (timer) {
        clearInterval(timer)
        timer = null
    }
}

const togglePlay = () => {
    if (playing.value) {
        pause()
    } else {
        play()
    }
}

const goTo = (index: number) => {
    pause()
    currentIndex.value = index
}

const prev = () => {
    pause()
    currentIndex.value = currentIndex.value > 0
        ? currentIndex.value - 1
        : timelapseFrames.value.length - 1
}

const next = () => {
    pause()
    currentIndex.value = currentIndex.value < timelapseFrames.value.length - 1
        ? currentIndex.value + 1
        : 0
}

const changeSpeed = (ms: number) => {
    speed.value = ms
    if (playing.value) {
        pause()
        play()
    }
}

// Restart al cambiar samples
watch(() => props.samples, () => {
    pause()
    currentIndex.value = 0
})

onBeforeUnmount(() => {
    pause()
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!

  return (timelapseFrames.value.length === 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          size: "48",
          color: "grey-lighten-2"
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode("mdi-image-off")
          ])),
          _: 1
        }),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-body-2 text-medium-emphasis mt-2" }, "Sin imágenes disponibles para timelapse", -1))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "position-relative",
          style: _normalizeStyle({ height: _ctx.height })
        }, [
          (currentFrame.value)
            ? (_openBlock(), _createBlock(_component_v_img, {
                key: 0,
                src: currentFrame.value.imageUrl,
                height: _ctx.height,
                cover: "",
                class: "rounded-lg timelapse-img"
              }, {
                placeholder: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    class: "fill-height ma-0",
                    align: "center",
                    justify: "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_progress_circular, {
                        indeterminate: "",
                        color: "white"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["src", "height"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_chip, {
              color: "black",
              variant: "flat",
              size: "small",
              class: "mr-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "14",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("mdi-clock-outline")
                  ])),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(formatDate(currentFrame.value!.time)), 1)
              ]),
              _: 1
            }),
            (currentFrame.value?.managed && currentFrame.value?.growthPercent != null)
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 0,
                  color: "success",
                  variant: "flat",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "14",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("mdi-trending-up")
                      ])),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(currentFrame.value.growthPercent) + "% ", 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_chip, {
              color: "black",
              variant: "flat",
              size: "x-small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(currentIndex.value + 1) + " / " + _toDisplayString(timelapseFrames.value.length), 1)
              ]),
              _: 1
            })
          ]),
          (currentFrame.value)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                icon: "",
                size: "small",
                color: "white",
                class: "position-absolute",
                style: {"top":"8px","right":"8px"},
                href: currentFrame.value.imageUrl,
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("mdi-open-in-new")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, {
                    activator: "parent",
                    location: "top"
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode("Abrir imagen")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["href"]))
            : _createCommentVNode("", true)
        ], 4),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_btn, {
            icon: "",
            size: "small",
            variant: "text",
            onClick: prev
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode("mdi-skip-previous")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            icon: "",
            size: "small",
            color: playing.value ? 'error' : 'primary',
            variant: "tonal",
            onClick: togglePlay,
            class: "mx-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(playing.value ? 'mdi-pause' : 'mdi-play'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(_component_v_btn, {
            icon: "",
            size: "small",
            variant: "text",
            onClick: next
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createTextVNode("mdi-skip-next")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_slider, {
            modelValue: currentIndex.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((currentIndex).value = $event)),
              _cache[1] || (_cache[1] = ($event: any) => (goTo($event)))
            ],
            max: timelapseFrames.value.length - 1,
            min: 0,
            step: "1",
            "hide-details": "",
            density: "compact",
            color: "primary",
            class: "mx-3"
          }, null, 8, ["modelValue", "max"]),
          _createVNode(_component_v_btn_toggle, {
            modelValue: speed.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((speed).value = $event)),
            mandatory: "",
            density: "compact",
            variant: "outlined",
            divided: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                value: 2500,
                size: "x-small",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (changeSpeed(2500)))
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode(" 0.5x ")
                ])),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                value: 1500,
                size: "x-small",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (changeSpeed(1500)))
              }, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createTextVNode(" 1x ")
                ])),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                value: 700,
                size: "x-small",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (changeSpeed(700)))
              }, {
                default: _withCtx(() => _cache[17] || (_cache[17] = [
                  _createTextVNode(" 2x ")
                ])),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                value: 300,
                size: "x-small",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (changeSpeed(300)))
              }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createTextVNode(" 4x ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode(_component_v_progress_linear, {
          "model-value": progress.value,
          height: "3",
          color: "primary",
          class: "mt-1",
          rounded: ""
        }, null, 8, ["model-value"]),
        (timelapseFrames.value.length <= 20)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timelapseFrames.value, (frame, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["timelapse-thumb", { 'timelapse-thumb-active': index === currentIndex.value }]),
                  onClick: ($event: any) => (goTo(index))
                }, [
                  _createVNode(_component_v_img, {
                    src: frame.imageUrl,
                    width: "48",
                    height: "36",
                    cover: "",
                    class: "rounded"
                  }, null, 8, ["src"])
                ], 10, _hoisted_7))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
}
}

})